import {
  Flex,
  Text,
  useColorModeValue,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useToast,
  Switch,
  Stack,
  Grid,
  Select,
  Tab,
  TabList,
  Tabs,
  TabPanel,
  TabPanels,
  Box,
} from '@chakra-ui/react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import SearchTable2 from 'components/Tables/SearchTable2';
import React, { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { totalRow } from 'state/roles-permissions';
import { AddIcon } from '@chakra-ui/icons';
import { checkForbidden } from 'helpers/checkForbidden';
import { useCMSActions } from 'hooks/useCMS';
import { menuAtom } from 'state/cms';
import { columnsDataMenu } from 'variables/columnsData';
import { RxReset } from 'react-icons/rx';
import { BsSearch } from 'react-icons/bs';
import { STATUS, MENU_TYPE, MENU_POSITION } from 'variables/general';

function DataTableMenu() {
  const textColor = useColorModeValue('gray.700', 'white');
  const listLocationWeb = useRecoilValue(menuAtom);
  const totalRows = useRecoilValue(totalRow);
  const cmsActions = useCMSActions();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCreate, setIsCreate] = useState(true);
  const [currentVenueWeb, setCurrentVenueWeb] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [newVenueWeb, setNewVenueWeb] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [refreshPagingDefault, setRefreshPagingDefault] = useState(false);
  const [parentMenus, setParentMenus] = useState([]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('This field is required'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const { register, handleSubmit, formState, reset, setValue, watch } = useForm(
    formOptions
  );
  const { errors, isSubmitting } = formState;
  const toast = useToast();

  // Search form
  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    watch: watchSearch,
    reset: resetSearch,
  } = useForm();

  useEffect(() => {
    // Load data mặc định khi vào trang
    const loadInitialData = async () => {
      let pageSize = 10;
      try {
        const s = localStorage && localStorage.getItem('currentPageSizeStore');
        if (s) pageSize = parseInt(s, 10) || 10;
      } catch (e) {}

      setIsFetching(true);
      await cmsActions.getListMenu(
        {
          status: undefined,
          sort_type: 'desc',
          sort_field: 'created_at',
        },
        0,
        pageSize
      );

      // Load parent menus cho dropdown
      const parentMenusRes = await cmsActions.getListParentMenus();
      if (parentMenusRes?.data?.data) {
        setParentMenus(parentMenusRes.data.data);
      }

      setIsFetching(false);
      setHasSearched(true);
    };

    loadInitialData();
  }, []);

  useEffect(() => {
    if (listLocationWeb) {
      const toolTypes = listLocationWeb.map((i) => ({
        ...i,
        filters: {
          name: watchSearch('nameSearch') || undefined,
          menu_type: watchSearch('menuTypeSearch') || undefined,
          menu_position: watchSearch('menuPositionSearch') || undefined,
          status: watchSearch('statusSearch') || undefined,
          parent_id: watchSearch('parentMenuSearch') || undefined,
        },
        typeSwitch: 'menu',
      }));
      setNewVenueWeb(toolTypes);
    }
  }, [
    listLocationWeb,
    watchSearch('nameSearch'),
    watchSearch('menuTypeSearch'),
    watchSearch('menuPositionSearch'),
    watchSearch('statusSearch'),
    watchSearch('parentMenuSearch'),
  ]);

  const onSubmitSearch = async (formValues) => {
    let pageSize = 10;
    try {
      const s = localStorage && localStorage.getItem('currentPageSizeStore');
      if (s) pageSize = parseInt(s, 10) || 10;
    } catch (e) {}
    setRefreshPagingDefault((v) => !v);
    recallApi({ pageIndex: 0, pageSize }, true);
  };

  const recallApi = async (fetchDataOptions, isFromSearch) => {
    setIsFetching(true);
    const pageIndex = fetchDataOptions?.pageIndex ?? 0;
    const pageSize = fetchDataOptions?.pageSize ?? 10;
    const params = {
      name: watchSearch('nameSearch') || undefined,
      menu_type: watchSearch('menuTypeSearch') || undefined,
      menu_position: watchSearch('menuPositionSearch') || undefined,
      status: watchSearch('statusSearch') || undefined,
      parent_id: watchSearch('parentMenuSearch') || undefined,
      sort_type: fetchDataOptions?.sort_type || 'desc',
      sort_field: fetchDataOptions?.sort_field || 'created_at',
    };

    if (hasSearched || isFromSearch) {
      await cmsActions.getListMenu(params, pageIndex, pageSize);
    }
    setIsFetching(false);
    if (isFromSearch) {
      setHasSearched(true);
    }
  };

  async function onSubmit({ name, slug, type, position, isActive, parent_id, order }) {
    const params = {
      name,
      type,
      position,
      parent_id: parseInt(parent_id),
      status: isActive ? 1 : 2,
      slug,
      order: order ? parseInt(order) : 0,
    };
    const listKeys = ['name'];
    const languages = listKeys
      .map((i) => {
        const value = watch(`${i}_vn`);
        if (!value && isCreate) {
          return undefined;
        }
        return {
          code: 'vi',
          locale_key: i,
          locale_value: value || '',
        };
      })
      .filter(Boolean);
    params.languages = languages;
    try {
      let res;
      if (isCreate) {
        res = await cmsActions.createMenu(params);
      } else {
        res = await cmsActions.updateMenu(params, currentVenueWeb);
      }

      if (res.status === 200) {
        onClose();
        reset();
        const message = isCreate
          ? 'Create Menu success'
          : 'Update Menu success';
        toast({
          description: message,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });

        // Reload với filter/search hiện tại
        let pageSize = 10;
        try {
          const s = localStorage && localStorage.getItem('currentPageSizeStore');
          if (s) pageSize = parseInt(s, 10) || 10;
        } catch (e) {}

        const params = {
          name: watchSearch('nameSearch') || undefined,
          menu_type: watchSearch('menuTypeSearch') || undefined,
          menu_position: watchSearch('menuPositionSearch') || undefined,
          status: watchSearch('statusSearch') || undefined,
          parent_id: watchSearch('parentMenuSearch') || undefined,
          sort_type: 'desc',
          sort_field: 'created_at',
        };

        await cmsActions.getListMenu(params, 0, pageSize);
      }
    } catch (err) {
      console.warn(err);
      toast({
        description: err?.response?.data?.meta?.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    }
  }

  async function editNews(newsID) {
    reset();
    const newsData = await cmsActions.getDetailMenu(newsID);
    if (newsData) {
      const {
        name,
        slug,
        type,
        position,
        parent_id,
        status,
        id,
        languages,
        order,
      } = newsData.data.data;
      setValue('name', name);
      setValue('slug', slug);
      setValue('type', type);
      setValue('position', position);
      setValue('parent_id', parent_id);
      setValue('order', order || 0);
      setValue('isActive', status === 1 ? true : false);
      setCurrentVenueWeb(id);
      if (languages) {
        languages.forEach((e) => {
          setValue(`${e.locale_key}_vn`, e.locale_value);
        });
      }
    }
    setIsCreate(false);
    onOpen();
  }

  return (
    <Card px='0px'>
      <CardHeader px='22px' mb='12px'>
        <Flex direction='column' display='block'>
          <Text
            float='left'
            color={textColor}
            fontSize='lg'
            fontWeight='bold'
            mb='6px'
          >
            Menu Management
          </Text>
          <Stack float='right' direction='row' spacing={4}>
            {checkForbidden(42) && (
              <Button
                size='sm'
                onClick={() => {
                  onOpen();
                  setIsCreate(true);
                }}
                leftIcon={<AddIcon />}
                colorScheme='blue'
                variant='outline'
              >
                Add Menu
              </Button>
            )}
          </Stack>
          {/* Search Form */}
          <Card mt={4}>
            <form
              id='menu-search-form'
              onSubmit={handleSubmitSearch(onSubmitSearch)}
            >
              <Flex
                direction='row'
                alignItems='center'
                mb={3}
                gap={4}
                flexWrap={'wrap'}
              >
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Name
                  </FormLabel>
                  <Input
                    ms='4px'
                    type='text'
                    size='sm'
                    placeholder='Search name'
                    name='nameSearch'
                    {...registerSearch('nameSearch')}
                  />
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Menu Type
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='menuTypeSearch'
                    {...registerSearch('menuTypeSearch')}
                  >
                    <option value=''>All</option>
                    {MENU_TYPE.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Menu Position
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='menuPositionSearch'
                    {...registerSearch('menuPositionSearch')}
                  >
                    <option value=''>All</option>
                    {MENU_POSITION.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Menu Parent
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='parentMenuSearch'
                    {...registerSearch('parentMenuSearch')}
                  >
                    <option value=''>All</option>
                    {parentMenus.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
                <Box direction='row' alignItems='center' display='block'>
                  <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                    Status
                  </FormLabel>
                  <Select
                    ms='4px'
                    type='text'
                    size='sm'
                    name='statusSearch'
                    {...registerSearch('statusSearch')}
                  >
                    {STATUS.map((item) => (
                      <option key={item.id} value={item.id === '0' ? '' : item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Select>
                </Box>
              </Flex>
              <Flex justify='center' align='center' gap='8px' mt={3}>
                <Button
                  leftIcon={<RxReset />}
                  variant='primary'
                  w='88px'
                  h='33px'
                  onClick={() => resetSearch()}
                >
                  Reset
                </Button>
                <Button
                  leftIcon={<BsSearch />}
                  variant='primary'
                  w='88px'
                  h='33px'
                  type='submit'
                >
                  Search
                </Button>
              </Flex>
            </form>
          </Card>
          <Modal
            closeOnOverlayClick={false}
            isOpen={isOpen}
            onClose={() => {
              onClose();
              reset();
            }}
            size='4xl'
          >
            <ModalOverlay />
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalContent>
                <ModalHeader>{isCreate ? 'Add Menu' : 'Edit Menu'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <Tabs isFitted variant='enclosed'>
                    <TabList>
                      <Tab
                        _focus={{ outline: 'none' }}
                        _selected={{ color: 'white', bg: 'blue.500' }}
                        fontWeight={'bold'}
                        fontSize={'18px'}
                      >
                        English
                      </Tab>
                      <Tab
                        _focus={{ outline: 'none' }}
                        _selected={{ color: 'white', bg: 'blue.500' }}
                        fontWeight={'bold'}
                        fontSize={'18px'}
                      >
                        Viet Nam
                      </Tab>
                    </TabList>
                    <TabPanels>
                      <TabPanel>
                        <Grid
                          templateColumns={{
                            sm: '1fr 1fr',
                            lg: 'repeat(2, 1fr)',
                          }}
                          gap='30px'
                          mt={2}
                        >
                          <FormControl isRequired>
                            <FormLabel fontSize='sm' fontWeight='semibold'>
                              Name
                            </FormLabel>
                            <Input
                              fontSize='sm'
                              ms='4px'
                              type='text'
                              placeholder='Name'
                              maxLength={250}
                              size='md'
                              name='name'
                              {...register('name')}
                            />
                          </FormControl>
                          <FormControl>
                            <FormLabel
                              color={textColor}
                              fontWeight='bold'
                              fontSize='xs'
                            >
                              Slug
                            </FormLabel>
                            <Input
                              fontSize='sm'
                              ms='4px'
                              type='text'
                              placeholder='Slug'
                              maxLength={250}
                              size='md'
                              name='slug'
                              {...register('slug')}
                              disabled={!isCreate}
                            />
                          </FormControl>
                        </Grid>
                        <Grid
                          templateColumns={{
                            sm: '1fr 1fr',
                            lg: 'repeat(4, 1fr)',
                          }}
                          gap='20px'
                          mt={2}
                        >
                          <FormControl>
                            <FormLabel
                              fontWeight='semibold'
                              fontSize='xs'
                              ms='4px'
                            >
                              Parent
                            </FormLabel>
                            <Select
                              ms='4px'
                              type='text'
                              defaultValue='0'
                              size='sm'
                              name='parent_id'
                              {...register('parent_id')}
                            >
                              <option key={0} value={0}>
                                Parent
                              </option>
                              {parentMenus.map((i) => (
                                <option key={i.id} value={i.id}>
                                  {i.name}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl>
                            <FormLabel
                              fontWeight='semibold'
                              fontSize='xs'
                              ms='4px'
                            >
                              Type
                            </FormLabel>
                            <Select
                              ms='4px'
                              type='text'
                              defaultValue='0'
                              size='sm'
                              name='type'
                              {...register('type')}
                            >
                              {['Parent', 'Show'].map((i) => (
                                <option key={i} value={i}>
                                  {i}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl>
                            <FormLabel
                              fontWeight='semibold'
                              fontSize='xs'
                              ms='4px'
                            >
                              Position
                            </FormLabel>
                            <Select
                              ms='4px'
                              type='text'
                              defaultValue='0'
                              size='sm'
                              name='position'
                              {...register('position')}
                            >
                              {['Top', 'Bottom'].map((i) => (
                                <option key={i} value={i}>
                                  {i}
                                </option>
                              ))}
                            </Select>
                          </FormControl>
                          <FormControl>
                            <FormLabel
                              fontWeight='semibold'
                              fontSize='xs'
                              ms='4px'
                            >
                              Order
                            </FormLabel>
                            <Input
                              ms='4px'
                              type='number'
                              placeholder='Order'
                              size='sm'
                              name='order'
                              {...register('order')}
                              min={0}
                            />
                          </FormControl>
                        </Grid>
                      </TabPanel>
                      <TabPanel>
                        <Grid
                          templateColumns={{
                            sm: '1fr 1fr',
                            lg: 'repeat(2, 1fr)',
                          }}
                          gap='30px'
                          mt={2}
                        >
                          <FormControl>
                            <FormLabel
                              ms='4px'
                              fontSize='sm'
                              fontWeight='normal'
                            >
                              Name
                            </FormLabel>
                            <Input
                              fontSize='sm'
                              ms='4px'
                              type='text'
                              placeholder='Name'
                              maxLength={250}
                              size='md'
                              name='name_vn'
                              {...register('name_vn')}
                            />
                          </FormControl>
                        </Grid>
                      </TabPanel>
                    </TabPanels>
                  </Tabs>
                  <FormControl>
                    <Switch
                      id='isChecked'
                      defaultChecked={isCreate && true}
                      name='isActive'
                      {...register('isActive')}
                      size='sm'
                      ms='4px'
                    >
                      Active
                    </Switch>
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isSubmitting}
                  >
                    {isCreate ? 'Create' : 'Update'}
                  </Button>
                  <Button
                    onClick={() => {
                      onClose();
                      reset();
                    }}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </form>
          </Modal>
        </Flex>
      </CardHeader>
      <CardBody>
        <SearchTable2
          tableData={newVenueWeb}
          columnsData={columnsDataMenu}
          totalRow={totalRows.menu}
          edit={editNews}
          actionsActive={['edit']}
          listPermissions={[43]}
          isFetching={isFetching}
          loadData={(fetchDataOptions) => recallApi(fetchDataOptions, false)}
          refreshPagingDefault={refreshPagingDefault}
        />
      </CardBody>
    </Card>
  );
}

export default DataTableMenu;
